// extracted by mini-css-extract-plugin
export var settingsList = "_38-0";
export var settingsRow = "_38-1";
export var warningDot = "_38-2";